<template>
  <div class="news-detail">
    <div class="news-detail-main">
      <!-- 加载中 -->
      <div v-if="loading" class="news-detail-loading">加载中...</div>

      <!-- 内容 -->
      <div v-else-if="post" class="news-detail-card">
        <!-- 返回列表（移动端同款：圆角方框箭头图标 + 文字） -->
        <div class="news-detail-back" @click="goBack">
          <span class="news-detail-back-icon">
            <svg width="7" height="13" viewBox="0 0 7 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6 1L1 6.5L6 12" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
          <span class="news-detail-back-text">返回</span>
        </div>

        <!-- 标题 + 信息 -->
        <h1 class="news-detail-title">{{ post.title }}</h1>
        <div class="news-detail-meta">
          <span v-if="post.date">发布于 {{ post.date }}</span>
          <span v-if="post.categoryName">{{ post.categoryName }}</span>
        </div>

        <!-- 正文（WordPress 富文本） -->
        <article class="news-content" v-html="post.content"></article>

        <!-- 标签：点击跳转到该标签的相关文章列表 -->
        <div class="news-detail-tags" v-if="post.tags && post.tags.length">
          <span
            v-for="tag in post.tags"
            :key="tag.id"
            class="news-detail-tag"
            @click="goTag(tag)"
          >
            #{{ tag.name }}
          </span>
        </div>
      </div>

      <!-- 加载失败 / 文章不存在 -->
      <div v-else class="news-detail-empty">
        <p>文章不存在或已删除</p>
        <div class="news-detail-back-btn" @click="goBack">返回资讯中心</div>
      </div>
    </div>
    <Foot></Foot>
  </div>
</template>

<script>
import { getPost } from "../req/wp";
import Foot from "@/components/Foot.vue";

export default {
  name: "NewsDetail",
  components: {
    Foot,
  },
  data: function () {
    return {
      post: null,
      loading: true,
    };
  },
  created: function () {
    this.load();
  },
  watch: {
    // keep-alive 缓存组件时 created 不会再次触发；
    // 从一篇详情切到另一篇（或从列表重新进入）时监听路由变化重新加载
    $route: function () {
      this.load();
    },
  },
  methods: {
    // 按路由参数加载文章详情，成功后同步页签标题与描述
    load: function () {
      const postId = this.$route.params.id;
      if (!postId) {
        this.loading = false;
        return;
      }
      // 先清空旧文章，避免切换文章瞬间闪现上一篇的内容
      this.post = null;
      this.loading = true;
      getPost(postId)
        .then((post) => {
          this.post = post;
          // 动态更新页签标题（与 Answer.vue 的做法一致）
          if (post && post.title) {
            document.title = post.title + " - 节点小宝";
            let descMeta = document.querySelector('meta[name="description"]');
            if (descMeta && post.excerpt) {
              descMeta.setAttribute("content", post.excerpt);
            }
          }
        })
        .catch((err) => {
          console.error("资讯详情加载失败", err);
          this.post = null;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 返回资讯列表页
    goBack: function () {
      this.$router.push("/news");
    },
    // 进入标签相关文章页
    goTag: function (tag) {
      this.$router.push("/news/tag/" + tag.id);
    },
  },
};
</script>

<style scoped lang="less">
.news-detail {
  min-height: 600px;
  background: #f7f9fe;

  .news-detail-main {
    width: 1040px;
    margin: 0 auto;
    padding: 40px 0 80px;
    box-sizing: border-box;
  }

  .news-detail-loading {
    padding: 100px 0;
    text-align: center;
    font-size: 16px;
    color: #999da6;
  }

  .news-detail-card {
    background: #ffffff;
    border: 1px solid #d8d8e8;
    border-radius: 12px;
    padding: 48px;
    box-sizing: border-box;

    .news-detail-back {
      display: inline-flex;
      align-items: center;
      gap: 10px;
      margin-bottom: 24px;
      font-size: 18px;
      font-weight: 500;
      color: #1d1f24;
      cursor: pointer;
      transition: color 0.2s;
      /* 移动端同款图标：圆角方框 + 内嵌左箭头 */
      .news-detail-back-icon {
        width: 28px;
        height: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #57576c;
        border: 1px solid rgba(23, 23, 27, 0.15);
        border-radius: 4px;
        box-sizing: border-box;
        transition: color 0.2s;
      }
      &:hover {
        color: #3772ff;
        .news-detail-back-icon {
          color: #3772ff;
        }
      }
    }

    .news-detail-title {
      font-size: 40px;
      font-weight: 700;
      line-height: 56px;
      color: #1d1f24;
      margin-bottom: 16px;
    }

    .news-detail-meta {
      display: flex;
      gap: 16px;
      padding-bottom: 24px;
      border-bottom: 1px solid #eef0f5;
      font-size: 14px;
      color: #999da6;
      span + span::before {
        content: "";
      }
    }
  }

  .news-detail-empty {
    padding: 120px 0;
    text-align: center;
    font-size: 16px;
    color: #666a73;
    .news-detail-back-btn {
      display: inline-block;
      margin-top: 24px;
      padding: 10px 32px;
      color: #ffffff;
      background: #3772ff;
      border-radius: 6px;
      cursor: pointer;
    }
  }

  // 标签区：文章底部展示的标签，点击进入相关文章列表
  .news-detail-tags {
    margin-top: 32px;
    padding-top: 24px;
    border-top: 1px solid #eef0f5;
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    .news-detail-tag {
      padding: 6px 16px;
      font-size: 14px;
      color: #3772ff;
      background: #eef4ff;
      border-radius: 16px;
      cursor: pointer;
      transition: all 0.2s;
      &:hover {
        color: #ffffff;
        background: #3772ff;
      }
    }
  }
}
</style>

<!-- v-html 注入的内容不带 scoped 的 data-v 属性，正文排版必须用全局样式兜底 -->
<style lang="less">
/* ---------- 正文排版（v-html 富文本） ---------- */
.news-content {
  margin-top: 32px;
  font-size: 16px;
  line-height: 1.8;
  color: #33343a;
  word-break: break-word;

  p {
    margin: 16px 0;
  }
  img {
    max-width: 100%;
    height: auto;
    border-radius: 8px;
    display: inline-block;
  }
  h1,
  h2,
  h3,
  h4 {
    margin: 28px 0 16px;
    font-weight: 700;
    color: #1d1f24;
  }
  h1 {
    font-size: 26px;
  }
  h2 {
    font-size: 22px;
  }
  h3 {
    font-size: 20px;
  }
  a {
    color: #3772ff;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
  blockquote {
    margin: 16px 0;
    padding: 12px 20px;
    border-left: 4px solid #3772ff;
    background: #f5f8ff;
    color: #666a73;
    border-radius: 0 8px 8px 0;
  }
  ul,
  ol {
    margin: 16px 0;
    padding-left: 28px;
    li {
      margin: 6px 0;
    }
  }
  table {
    width: 100%;
    border-collapse: collapse;
    margin: 16px 0;
    th,
    td {
      padding: 8px 12px;
      border: 1px solid #e4e6ee;
      text-align: left;
    }
    th {
      background: #f5f6fa;
      font-weight: 600;
    }
  }
  pre,
  code {
    font-family: Consolas, Monaco, "Courier New", monospace;
    background: #f5f6fa;
    border-radius: 4px;
  }
  pre {
    padding: 16px;
    overflow-x: auto;
    code {
      background: transparent;
      padding: 0;
    }
  }
  code {
    padding: 2px 6px;
    font-size: 14px;
  }
}
</style>
